module.exports = __webpack_public_path__ + "static/img/duom033.1495f07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/duom033.png
// module id = 990
// module chunks = 0